var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{attrs:{"fill":"currentColor","viewBox":"0 0 24 24","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M7,10L12,15L17,10H7Z","fill":"currentColor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }